// extracted by mini-css-extract-plugin
export default {"rating":"lI-z","numberOfStars":"mI-z","count":"nI-z","barGraphSpacing":"oI-z","barGraph":"pI-z"};